import { AdministrationHelper } from "@/Administration/Helpers/AdministrationHelper";
import { CheckboxControl } from "@/Common/Components/Inputs/CheckboxControl";
import { useTranslation } from "@/Common/CustomHooks/useTranslation";
import { SiteSpecialtyId } from "@/Common/Models/Sites/SiteSpecialtyId";

interface IOfferedSpecialtiesSubSectionProps {
    specialties: SiteSpecialtyId[];
    offeredSpecialtyIds: string[];
}

function OfferedSpecialtiesSubSection(props: IOfferedSpecialtiesSubSectionProps): JSX.Element {
    const { specialties, offeredSpecialtyIds } = props;
    const { getText } = useTranslation();

    return (
        <>
            <div className="view-subsection-header row">
                <div className="col-lg-4 col-md-2 col-sm-2 text-right">
                    <h4 className="view-subsection-title">{getText("ClinicInfo_OfferedSpecialtiesLabel")}</h4>
                </div>
            </div>

            <div className="view-subsection-body">
                <div className="row">
                    <div className="col-lg-4 col-md-2 col-sm-2 text-right" />
                    <div className="col-lg-5 col-md-6 col-sm-6 form-field-answer">
                        <label className="form-label">{getText("ClinicInfo_OfferedSpecialitiesPortalInfoLabel")}</label>
                    </div>
                </div>
                {specialties?.map((specialty: SiteSpecialtyId, index: number) => {
                    const isSelected = offeredSpecialtyIds?.contains(AdministrationHelper.getSpecialtyDictionaryOrLookupId(specialty));
                    const label = AdministrationHelper.getSpecialityByCurrentLanguage(specialty);

                    return (
                        <div key={`specialty_${index}`} className="row">
                            <div className="col-lg-4 col-md-2 col-sm-2 text-right" />
                            <div className="col-lg-5 col-md-6 col-sm-6 form-field-answer">
                                <CheckboxControl
                                    label={label}
                                    checked={isSelected}
                                    disabled
                                />
                            </div>
                        </div>
                    );
                })}
            </div>
        </>
    );
}

export { IOfferedSpecialtiesSubSectionProps };
export default OfferedSpecialtiesSubSection;
